import BASEURLGESTTOR from '../api/gesttor'
import { BASEURLGESTTORFORMDATA, BASEAPIGESTTORAUTH } from '../api/gesttor'
import { cadastrarOrganizacaoPayload, paramsOrganizacao, organizacoesAtualizarPayload, organizacaoGestaoAtualizar, atualizarAvatar } from '../../interfaces/organizacao'

export function novaOrganizacao (payload: cadastrarOrganizacaoPayload) {
    return BASEAPIGESTTORAUTH.post('/organizacao', payload)
}

export function dadosOrganizacao () {
    return BASEURLGESTTOR.get ('/organizacao')
}

export function atualizarOrganizacao (payload: organizacoesAtualizarPayload) {
    return BASEURLGESTTOR.patch('/organizacao', payload)
}

export function atualizarAvatarOrganizacao (payload: atualizarAvatar) {
    return BASEURLGESTTORFORMDATA.patch('/organizacao/avatar', payload)
}

export function clientesGesttor (params: paramsOrganizacao) {
    return BASEURLGESTTOR.get(`/organizacao/clientes?termo=${params.termo}&situacao=${params.situacao}`)
}

export function licencasGesttor (idOrganizacao: string, payload: organizacaoGestaoAtualizar) {
    return BASEURLGESTTOR.patch(`/organizacao/clientes/${idOrganizacao}`, payload)
}
